import { render } from "./rsg-header.vue?vue&type=template&id=26f912bb&lang=pug"
import script from "./rsg-header.vue?vue&type=script&lang=js"
export * from "./rsg-header.vue?vue&type=script&lang=js"

import "./rsg-header.vue?vue&type=style&index=0&id=26f912bb&lang=sass"

import exportComponent from "/builds/WebServers/festival/leaderboards/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__